import { Injectable } from '@angular/core';
import {  HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../../environments/environment';

import { Cheque } from "./cheque.model";

@Injectable({
  providedIn: 'root'
})

export class ChequeService {

  selectedCheque: Cheque;
  ChequeList: Cheque[];

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDCheque(cheque: Cheque) {

    cheque.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    //cheque.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    cheque.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    cheque.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = cheque;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Cheque/IUD', body, { headers: headers });
  }

  GetBranchList(){

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Branch', body, { headers: headers });
  }

  GetBankList(){
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Bank', body, { headers: headers });
  }

  FetchChequeByChequeNo(cheque) {
    let body = cheque;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Cheque/Fetch', body, { headers: headers });
  }

  //-----------------------------FetchChequeList----Component-------------------------------------
  FetchChequeList() {
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Cheque/FetchList', body, { headers: headers });
  }

}
